import qs from 'qs';

export function getQueryParameters(
  url: string = window.location.search
): { [key: string]: string } {
  if (!url) return {};
  if (!url.startsWith('?')) {
    return {};
  }
  const query = url.slice(1);
  return qs.parse(query);
}
